import React from 'react';
import { Icon, Avatar as UserAvatar } from '@shoflo-rundown/polymer.legacy';
import classNames from 'classnames';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import moment from 'moment-timezone';
import role from 'shared/lib/role';
import {
  DisplayForAdmin,
  DisplayForNonAdmin,
} from 'shared/components/misc/displayForRole.jsx';
import Proof from './proof';

/**
 * Proof of performance
 *
 */
const ProofOfPerformanceCell = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return { hover: false };
  },

  render() {
    const {
      item,
      timeZone,
      twentyFourHourClock,
      cellHeight,
      rowIndex,
    } = this.props;
    const { hover } = this.state;
    const { params } = this.context.router.state;

    if (item.has('proof') && item.hasIn(['proof', 'createdBy'])) {
      const proof = item.get('proof');

      let hasAdminRole = this._hasEventAdminRole();

      let mom = moment(item.getIn(['proof', 'createdOn'])),
        note = item.getIn(['proof', 'note']);

      if (timeZone) {
        mom = mom.tz(timeZone);
      }

      return (
        <div className="cs-proof-wrapper cs-cell cs-data-cell">
          <div
            className={classNames('cs-proof', {
              'cs-proof-readonly': !hasAdminRole,
            })}
            onMouseOver={this._setHover}
            onMouseLeave={this._setHover}
          >
            <div>
              <UserAvatar
                height="28px"
                width="28px"
                user={item.getIn(['proof', 'createdBy']).toJS()}
              />

              <div className="cs-proof-timestamp">
                {mom.format(
                  `MM/DD/YYYY @ ${
                    twentyFourHourClock ? 'HH:mm:ss' : 'hh:mm:ssa'
                  }`,
                )}
              </div>

              <DisplayForNonAdmin {...params}>
                <div className="cs-proof-note">
                  <div className="cs-proof-note-readonly">{note}</div>
                </div>
              </DisplayForNonAdmin>

              <DisplayForAdmin {...params}>
                {proof && (
                  <Proof note={note} rowIndex={rowIndex} hover={hover} />
                )}
              </DisplayForAdmin>

              <DisplayForAdmin {...params}>
                <div className="cs-proof-action-btns">
                  <ProofButton
                    icon="clock-o"
                    onClick={this._addProof}
                    circle
                    cellHeight={cellHeight}
                  />

                  <ProofButton
                    icon="trash"
                    onClick={this._clearProof}
                    circle
                    cellHeight={cellHeight}
                  />

                  <ProofButton
                    icon="list"
                    onClick={this._showProofHistory}
                    circle
                    cellHeight={cellHeight}
                  />
                </div>
              </DisplayForAdmin>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cs-proof-wrapper circle-btn cs-cell cs-data-cell">
        <DisplayForAdmin {...params}>
          <div className="cs-proof-wrapper-btns">
            <ProofButton
              icon="clock-o"
              onClick={this._addProof}
              cellHeight={cellHeight}
            />

            <ProofButton
              icon="list"
              onClick={this._showProofHistory}
              cellHeight={cellHeight}
            />
          </div>
        </DisplayForAdmin>
      </div>
    );
  },

  _addProof() {
    CuesheetRowActions.addItemRowProof(this.props.rowIndex);
  },

  _clearProof() {
    CuesheetRowActions.clearItemRowProof(this.props.rowIndex);
  },

  _showProofHistory() {
    const { item, rowId } = this.props;
    CuesheetRowActions.showProofHistory(rowId, item);
  },

  _hasEventAdminRole() {
    let params = this.context.router.state.params;
    let { teamId, eventId } = params;
    let { user } = this.props;

    if (!user) return;

    return role.hasEventAdminRole(user, teamId, eventId);
  },

  _setHover(e) {
    const { type } = e;
    if (type === 'mouseover') this.setState({ hover: true });
    if (type === 'mouseleave') this.setState({ hover: false });
  },
});

export default ProofOfPerformanceCell;

/* eslint-disable react/prop-types */
const ProofButton = ({ onClick, circle, icon, cellHeight }) => {
  let heightClass = cellHeight > 20 ? 'large' : 'small';
  let btnClass = circle
    ? 'cs-proof-circle-button-time'
    : 'cs-proof-circle-button';

  return (
    <div onClick={onClick} className={classNames(btnClass, heightClass)}>
      <Icon name={icon} size={1} />
    </div>
  );
};
/* eslint-enable react/prop-types */
